import { Accordion } from '../../../../../components/general/accordion';
import SubjectIcon from '@mui/icons-material/Subject';
import { TitleV1 } from '../../../../../components/titleV1';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CASES_GENERAL } from '../../../../../../routes/paths';
import { CasesGeneralForm } from '../../../casesGeneral/form';

export const AccountRegisterCaseGeneral = () => {
    const navigate = useNavigate();

    return (
        <Accordion
            title="REGISTRO CASO GENERALES"
            icon={<SubjectIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
            padding={0}
        >
            <TitleV1 title="CASOS GENERALES">
                <LoadingButtonGeneral
                    title="Buscar"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    onClick={() => navigate(CASES_GENERAL)}
                />
            </TitleV1>
            <Grid px="16px">
                <CasesGeneralForm />
            </Grid>
        </Accordion>
    );
};
